import { create } from "zustand";

interface CaptureStoreState {
  iframe: HTMLIFrameElement | null;
  setIframe: (iframe: HTMLIFrameElement) => void;
  setCompany: (company: string) => void;
  setEntryPoint: (path: string) => void;
}

export const useCaptureStore = create<CaptureStoreState>((set, get) => ({
  iframe: null,
  setIframe: (iframe) => set({ iframe }),
  setCompany: (company) => {
    const { iframe } = get();
    iframe?.contentWindow?.postMessage(
      {
        action: "SET_COMPANY",
        company,
      },
      "*",
    );
  },
  setEntryPoint: (path) => {
    const { iframe } = get();
    iframe?.contentWindow?.postMessage(
      {
        action: "SET_ENTRY_POINT",
        path,
      },
      "*",
    );
  },
}));
